import '.a{display:grid;}.ssr-plugin'
import '.g{gap:1rem;}.ssr-plugin'
import '.a2{align-items:stretch;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.dn{min-height:0px;}.ssr-plugin'
import '.at{height:100%;}.ssr-plugin'
import frieslandImage from '@app/assets/images/rabobank-landing/cpo-desk/friesland.jpg'
import noordHollandImage from '@app/assets/images/rabobank-landing/cpo-desk/noord-holland-noord.jpg'
import groningenImage from '@app/assets/images/rabobank-landing/cpo-desk/groningen.jpg'
import limburgImage from '@app/assets/images/rabobank-landing/cpo-desk/limburg.jpg'
import metropoolImage from '@app/assets/images/rabobank-landing/cpo-desk/metropool.jpg'
import middenOostImage from '@app/assets/images/rabobank-landing/cpo-desk/midden-oost-nederland.jpg'
import brabantImage from '@app/assets/images/rabobank-landing/cpo-desk/oost-brabant.jpg'
import achterhoekImage from '@app/assets/images/rabobank-landing/cpo-desk/twente-achterhoek.jpg'
import zuidWestImage from '@app/assets/images/rabobank-landing/cpo-desk/zuid-west.jpg'
import peopleBuildingImage from '@app/assets/images/rabobank-landing/people-building.jpg'
import peopleInRoomImage from '@app/assets/images/rabobank-landing/people-in-the-room.jpg'
import useMediaQuery from '@app/util/useMediaQuery'
import { styled } from 'inlines'
import { Card } from '@app/components/blocks/card/Card'

const cpoDesks = [
    {
        label: 'Groningen Drenthe',
        image: groningenImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011205831/samen-aan-de-slag-met-zelfbouw-onze-cpo-desk-helpt'
    },
    {
        label: 'Friesland',
        image: frieslandImage,
        link: 'https://www.rabobank.nl/lokale-bank/friesland/cpo-desk'
    },
    {
        label: 'Midden Oost Nederland',
        image: middenOostImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011423327/samen-aan-de-slag-met-zelfbouw-onze-cpo-desk-helpt'
    },
    {
        label: 'Twente Achterhoek',
        image: achterhoekImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011203655/rabobank-lanceert-cpo-desk'
    },
    {
        label: 'Gelderland Zuid',
        image: peopleInRoomImage,
        link: 'https://www.rabobank.nl/lokale-bank/rijk-van-nijmegen/onze-cooperatieve-bijdrage'
    },
    {
        label: 'Midden Nederland',
        image: peopleInRoomImage,
        link: 'https://www.rabobank.nl/lokale-bank/utrecht-en-omstreken/onze-cooperatieve-bijdrage'
    },
    {
        label: 'Noord Holland Noord',
        image: noordHollandImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011201222/samen-aan-de-slag-met-zelfbouw-onze-cpo-desk-helpt'
    },
    {
        label: 'Metropool Regio Amsterdam',
        image: metropoolImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011461985/samen-zelfbouwen'
    },
    {
        label: 'Leiden Haaglanden',
        image: peopleBuildingImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011420609/rabobank-lanceert-cpo-desk'
    },
    {
        label: 'Zuid Holland Midden',
        image: peopleBuildingImage,
        link: 'https://www.rabobank.nl/lokale-bank/zuid-holland-midden/onze-cooperatieve-bijdrage'
    },
    {
        label: 'Zuid West Nederland',
        image: zuidWestImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011164843/rabobank-lanceert-cpo-desk'
    },
    {
        label: 'Midden Brabant',
        image: peopleInRoomImage,
        link: 'https://www.rabobank.nl/lokale-bank/hart-van-brabant/onze-cooperatieve-bijdrage'
    },
    {
        label: 'Oost Brabant',
        image: brabantImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011166154/rabo-oost-brabant-lanceert-cpo-desk'
    },
    {
        label: 'Limburg',
        image: limburgImage,
        link: 'https://www.rabobank.nl/lokale-bank/nieuws/011160720/rabobank-ondersteunt-collectieve-woonvormen-in-limburg'
    }
]

export const CpoDesks = () => {
    const isMobile = useMediaQuery()

    return (
        <div className="a g a2"
            style={{
                gridTemplateColumns: isMobile ? '1fr 1fr' : '1fr 1fr 1fr 1fr',}}
        >
            {cpoDesks.map((cpoDesk) => (
                <div className="d dn at"
                    key={cpoDesk.label}
                >
                    <Card 
                        image={cpoDesk.image} 
                        title={cpoDesk.label} 
                        onClick={() => window.open(cpoDesk.link, '_blank', 'noopener,noreferrer')} 
                        padded={false}
                        orientation="vertical"
                        style={{
                            flex: 1,
                            minHeight: '17.5rem',
                            height: '100%',
                        }}
                    />
                </div>
            ))}
        </div>
    )
}
